import moment from 'moment-timezone';

import { Box } from '@hivebrite/design-system/Box';
import { Divider } from '@hivebrite/design-system/Divider';
import { CheckboxInput } from '@hivebrite/design-system/Inputs';
import { useToggle } from '@hivebrite/react-hooks';

import { RECURRING_MODES } from 'hb-react/shared/apps/Memberships/constants/membership';
import { translations } from 'hb-react/shared/apps/Memberships/utils/translations';

const RenewalPolicy = ({ membership, onAutomaticRenewal }) => {
  const { payment_options: paymentOptions = [] } = membership;

  const selectedPaymentOption =
    paymentOptions.find(({ selected }) => selected) || // no draft cart
    paymentOptions.find(({ cartItem }) => cartItem?.id) || // draft cart
    membership; // no payment options

  const recurringAllowed =
    selectedPaymentOption.recurring_mode === RECURRING_MODES.RECURRING_ALLOWED;

  if (!recurringAllowed) {
    return null;
  }

  return (
    <Box mt={8}>
      <RenewalPolicyContent
        onAutomaticRenewal={onAutomaticRenewal}
        selectedPaymentOption={selectedPaymentOption}
      />
    </Box>
  );
};

const RenewalPolicyContent = ({
  selectedPaymentOption = {},
  onAutomaticRenewal,
}) => {
  const {
    id,
    periodicity,
    validity,
    cartItem,
    recurring_payment_enabled: enabled,
  } = selectedPaymentOption;
  const { toggle, isOpen: checked } = useToggle(cartItem?.recurring || enabled);
  const validityFormatted = moment(validity).format('L');

  const onChange = (event) => {
    toggle();
    onAutomaticRenewal({
      ...selectedPaymentOption,
      recurring_payment_enabled: event.target.checked,
    });
  };

  return (
    <Box flexDirection="column" width="100%">
      <Box font="h3-semibold">{s__('Memberships|Renewal policy')}</Box>
      <Divider borderBottomColor="horizon" mt={4} mb={5} width="100%" />
      <Box display="block">
        <CheckboxInput
          onChange={onChange}
          checked={checked}
          id={`automatic-renewal-${id}`}
          label={
            <Box
              flexDirection="column"
              data-testid="registration-automatic-renew-label"
            >
              <Box font="h4-semibold" mb={1}>
                {s__('Memberships|Automatic renew every %{periodicity}').i__({
                  periodicity: translations.periodicity[periodicity],
                })}
              </Box>
              <Box font="body-dove-italic">
                {s__(
                  'Memberships|By selecting this option, you allow us to recharge your payment method on %{validity}. If you do not select this option, this membership will end on %{expiresAt}.',
                ).i__({
                  validity: validityFormatted,
                  expiresAt: validityFormatted,
                })}
              </Box>
            </Box>
          }
        />
      </Box>
    </Box>
  );
};

export default RenewalPolicy;
